import { savedSearchesFetched, requestStarted, onAppError } from '../Actions';
import { reportError } from './AppErrorThunk';
// FETCH
import SavedSearchesFetch from '../../../fetch/SavedSearchesFetch';

export function fetchSavedSearches(callback = null) {
  return function (dispatch) {
    dispatch(requestStarted());

    // In a real world app, you also want to
    // catch any error in the network call.
    return SavedSearchesFetch.getAll()
      .then(
        (json) => dispatch(savedSearchesFetched(json)),
        // Do not use catch, because that will also catch
        // any errors in the dispatch and resulting render,
        // causing an loop of 'Unexpected batch number' errors.
        // https://github.com/facebook/react/issues/6895
        // error => console.log('An error occured.', error)
        (error) => dispatch(onAppError(error))
      )
      .then(
        (json) =>
          // We can dispatch many times!
          // Here, we update the app state with the results of the API call.

          callback && dispatch(callback)
      )
      .catch((error) => {
        dispatch(reportError(error));
      });
  };
}
